// Centralized hero slides and other slideshow-friendly content
// Export a named constant for easy tree-shaking and future tooling

export const heroSlides = [
  {
    id: "events",
    title: "Romantic Wedding Moments",
    description: "Capturing love stories that last forever",
    thumbnail:
      "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=800&h=600&fit=crop",
    theme: "events",
    subtitle: "Cinematic Excellence",
  },
  {
    id: "realestate",
    title: "Architectural Real Estate Tours",
    description: "Showcasing spaces that sell themselves",
    thumbnail:
      "https://images.unsplash.com/photo-1464983953574-0892a716854b?w=800&h=600&fit=crop",
    theme: "realestate",
    subtitle: "Professional Showcase",
  },
  {
    id: "marketing",
    title: "Bold Marketing Campaigns",
    description: "Creating content that converts viewers into customers",
    thumbnail:
      "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?w=800&h=600&fit=crop",
    theme: "marketing",
    subtitle: "Performance Driven",
  },
  {
    id: "design",
    title: "Design Fiction Concepts",
    description: "Visualizing tomorrow's possibilities today",
    thumbnail:
      "https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=800&h=600&fit=crop",
    theme: "design",
    subtitle: "Future Focused",
  },
];

// Hero slider settings
export const heroSettings = {
  // Autoplay interval (ms)
  intervalMs: 10000,
};

export default heroSlides;
